import axios from '../axios'

export const termList = (data) => {
  return axios({
    url: '/con/manage/term/list',
    method: 'GET',
    data
  })
}
//查询下拉列表
export const selectCurrentConfig = (data) => {
  return axios({
    url: '/con/manage/term/course/selectCurrentConfig',
    method: 'POST',
    data
  })
}
//开班设置下的学期课程列表
export const courseList = (data) => {
  return axios({
    url: '/con/manage/term/course/list',
    method: 'POST',
    data
  })
}
//查看开班列表下的课程详情
export const courseDetail = (data) => {
  return axios({
    url: '/con/manage/term/course/detail',
    method: 'GET',
    data
  })
}
//设置开班/不开班状态
export const setCourseStatus = (data) => {
  return axios({
    url: '/con/manage/term/course/setCourseStatus',
    method: 'POST',
    data
  })
}

//设置报名节点
export const setApplyTime = (data) => {
  return axios({
    url: '/con/manage/term/course/setApplyTime',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/shiftSetting.js